import { Checkbox } from "pretty-checkbox-react";
import { useState } from "react";
import { useParams } from "react-router";
import Select from "react-select";
import {
	SeshTextChannelData,
	SyncInclusionType,
} from "../../../../../../../common/sesh_types";
import { DashboardUtils } from "../../../../dashboard_utils";
import { trpc } from "../../../../utils/trpc";
import GuildSettingsChannelPicker, {
	RequiredPermission,
} from "./guild_settings_channel_picker";

export default function IncludedSeshEventsDropdown(props: {
	included_sesh_events: SyncInclusionType | null;
	set_included_sesh_events: (included_sesh_events: SyncInclusionType) => void;
	included_channel: string;
	set_included_channel: (included_channel: string) => void;
	hasUnsavedChanges: boolean;
	include_existing_events?: boolean;
	set_include_existing_events?: (include_existing_events: boolean) => void;
}) {
	let { server_id } = useParams<{ server_id: string }>();

	const header = DashboardUtils.CreateHeaderAndInfoButton(
		<>
			Select which <span className="sesh-text">sesh</span> events to
			include
		</>,
		"Choose which events will be sent to Google Calendar",
		false,
		false,
		props.hasUnsavedChanges
	);

	const optionsByType = {
		[SyncInclusionType.All]: {
			value: SyncInclusionType.All,
			label: "All",
		},
		[SyncInclusionType.Channel]: {
			value: SyncInclusionType.Channel,
			label: "Channel",
		},
		[SyncInclusionType.RSVP]: {
			value: SyncInclusionType.RSVP,
			label: "My RSVPed events",
		},
	};

	const options = [
		optionsByType[SyncInclusionType.All],
		optionsByType[SyncInclusionType.Channel],
		optionsByType[SyncInclusionType.RSVP],
	];

	const [selectedType, setSelectedType] = useState(
		props.included_sesh_events !== null &&
			props.included_sesh_events !== undefined
			? optionsByType[props.included_sesh_events]
			: optionsByType[SyncInclusionType.All]
	);

	const previewEventCountQuery = trpc.gcal.previewEventCount.useQuery(
		{
			guild_id: server_id,
			included_sesh_events: props.included_sesh_events,
			included_channel: props.included_channel,
		},
		{
			enabled:
				props.included_sesh_events !== SyncInclusionType.Channel ||
				Boolean(props.included_channel),
		}
	);

	return (
		<div>
			{header}
			<div className="flex flex-col gap-2">
				<Select
					isSearchable={false}
					classNamePrefix="sesh-dropdown"
					//filterOption={filterOptions}
					options={options}
					value={selectedType}
					onChange={(newValue) => {
						props.set_included_sesh_events(newValue.value);
						if (
							newValue.value !== SyncInclusionType.Channel &&
							props.included_channel
						) {
							props.set_included_channel(null);
						}
						setSelectedType(newValue);
					}}
				/>
				{props.included_sesh_events === SyncInclusionType.Channel && (
					<GuildSettingsChannelPicker
						channel={props.included_channel}
						set_channel={props.set_included_channel}
						requiredPermission={RequiredPermission.Read}
					/>
				)}
				{props.set_include_existing_events && (
					<span
						className="checkbox-wrapper flex cursor-pointer items-center gap-2"
						onClick={() => {
							props.set_include_existing_events(
								!props.include_existing_events
							);
						}}
					>
						<Checkbox
							className="title-checkbox"
							name="include_existing_events"
							checked={props.include_existing_events}
							onChange={() => {
								props.set_include_existing_events(
									!props.include_existing_events
								);
							}}
						></Checkbox>
						<span>
							Include existing events{" "}
							{previewEventCountQuery.isSuccess
								? `(${previewEventCountQuery.data})`
								: ""}
						</span>
					</span>
				)}
			</div>
		</div>
	);
}
